import { Post, Get, Patch, Put, Delete, Download, ax } from './http';
import { type } from './interface';
import qs from 'qs';
export namespace EnterpriseApi {
    /**
    *  获取企业机构代码信息
    */
    export var GetEnterpriseList = (body: any): Promise<any> => {
        return Get(`/csp/Enterprise/GetEnterpriseCodeFromQcc?${qs.stringify(body)}`, {});
    };
    /**
    *  获取客户单位详细
    */
    export var GetEnterpriseDetail = (body: any): Promise<any> => {
        return Get(`/csp/Enterprise/detail?${qs.stringify(body)}`, {});
    };
    /**
     * 编辑客户单位
     */
    export var UpdateEnterprise = (id: any, body: any): Promise<any> => {
        return Put(`/csp/Enterprise/${id}`, body);
    };
}